export var EmploymentType;
(function (EmploymentType) {
    EmploymentType["Employee"] = "EMPLOYEE";
    EmploymentType["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentType["Other"] = "UNKNOWN";
})(EmploymentType || (EmploymentType = {}));
//# sourceMappingURL=index.js.map